import React, { useState, useEffect, useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";

import { actions as rmSagaActions  } from "../redux/receiptManagementSaga";
import { actions as rmReducerActions } from "../redux/receiptManagementSlice";
import { refSagaActions } from "../../Administration/ReferenceInfoManagement";

import { ReceiptVerifyModal } from "./ReceiptVerifyModal";
import { ServiceRender } from "./ServiceRender";
import { ReceiptNotFound } from "./ReceiptNotFound";

import { Search, Check2Circle, FileEarmarkCheck } from "react-bootstrap-icons";
import { Button, Form, Col, Row, Card, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import styles from "../css/receiptManagement.module.css";


//search form schema definition
const verificationFormSchema = Yup.object().shape({
  prioritySearch: Yup.object({}),
  receiptNumber: Yup.string()
    .matches(/^[Ee]{1}[Rr]{1}[Gg]{1}[A-Za-z0-9]{10}$/, "*Invalid Receipt format")
    .min(13, "*Incorrect length")
    .max(13, "*Incorrect length")
    .required("*Enter a receipt number")
});

// function downloadPDFReport(dataStr){
  
//   if (dataStr && dataStr.length === 0){
//     return;
//   }
//   const filename = `Service Render Confirmation.pdf`;
//   const link = document.createElement("a");
//   let data = 'data:application/pdf;base64,' + dataStr;
//   link.setAttribute("href", data);
//   link.setAttribute("download", filename);
//   link.click();
// };

export function ReceiptVerificationForm() {
  const dispatch = useDispatch();

  const { auth, receiptManagement, reference } = useSelector((state) => state);

  const { user } = auth;
  const { verifiedReceipt, verifyingOTP, otpVerified, updatingRcptStat, searchingRcpt,  receiptStatusUpdated, otpVerifiedResponse /* updatedReceipt, reportDataStr, fetchingReport*/ } = receiptManagement;


  const provAgencyId = user.prov_agency_id;
  const initialParam = { receiptNumber: "" };
  const { allReferences, referenceKinds } = reference;
  
  const [ showVerificationModal, setShowVerificationModal ] = useState(false);
  const [ servRndModal, setServRndModal ] = useState(false);
  const [ searchMade, setSearchMade ] = useState(false);
  const [ currRcptStat, setCurrRcptStat ] = useState({});
  const [ verifiedReceiptFound, setVerifiedReceiptFound ] = useState({});
  const [ receiptNotFound, setReceiptNotFound ] = useState(false);
  const [ searchedRcpt, setSearchedRcpt ] = useState({});
  const [ usedRcptStatId, setUsedRcptStatId ] = useState({});
  const [ issuedRcptStatId, setIssuedRcptStatId ] = useState({});
  //const [ downloadReport, setDownloadReport ] = useState(false);


  const handleOTPSend = useCallback( () => {
    let query = {
      str: verifiedReceipt.rcpt_number
    };
    dispatch(rmSagaActions.sendOTPCode(query));
  },[verifiedReceipt,dispatch]);


  useEffect(() => {
    dispatch(rmReducerActions.reset());
    dispatch(refSagaActions.fetchAllReferences());
    dispatch(refSagaActions.fetchReferenceKinds());
  }, [dispatch]);
  
  useEffect(() => {
    if(referenceKinds.length > 1){
      let receiptStatusKind = referenceKinds.find((kind) => (kind.code === "RECEIPT_STATUS"));
      let recStats = allReferences.filter((ref) => (ref.kindId === receiptStatusKind.id && ref.description !== "Invalid"));
      let usedRcpt = recStats.filter((rcpt) => rcpt.description === "Used")[0];
      let issuedRcpt = recStats.filter((rcpt) => rcpt.description === "Issued")[0];
      setUsedRcptStatId(usedRcpt);
      setIssuedRcptStatId(issuedRcpt);
    }
  }, [referenceKinds, allReferences]);
  
  useEffect(() => {
    
    if(verifiedReceipt && Object.keys(verifiedReceipt).length > 3 && searchMade){
      setVerifiedReceiptFound(verifiedReceipt);
      if(verifiedReceipt.rcpt_status_id === issuedRcptStatId.id && verifiedReceipt.pa_id === provAgencyId){
        handleOTPSend();
      }

      setCurrRcptStat(verifiedReceipt.rcpt_status_desc);
      setShowVerificationModal(true);
      setSearchMade(false);
    } else if((verifiedReceipt === null || verifiedReceipt === undefined) && searchMade){
      setReceiptNotFound(true);
      dispatch(rmReducerActions.verifiedReceiptCleared());
      setSearchMade(false);
      setVerifiedReceiptFound({});
    }
  }, [verifiedReceipt, searchMade, dispatch,handleOTPSend, issuedRcptStatId, provAgencyId]);

  // useEffect(() => {
  //   if(downloadReport && reportDataStr && receiptStatusUpdated){
  //     if(reportDataStr.length > 1){
  //       downloadPDFReport(reportDataStr);
  //       setDownloadReport(false);
  //       setSearchMade(false);
  //     }
  //   }
  // }, [receiptStatusUpdated, reportDataStr, downloadReport]);


  useEffect(() => {
    if (otpVerified){
      setShowVerificationModal(false);
      setServRndModal(true);
    }
  }, [otpVerified]);

  useEffect(() => {
    if(receiptStatusUpdated){
      setServRndModal(false);
    }
  }, [receiptStatusUpdated]);


  const handleVerifyReceipt = (query) => {

    dispatch(rmSagaActions.verifyReceipts(provAgencyId, query));
  };

  const handleFindReceipt = (query) => {
    dispatch(rmReducerActions.reset());
    setSearchMade(true);
    setSearchedRcpt(query.receiptNumber);
    setShowVerificationModal(false);
    setServRndModal(false);

    let rcpt = { str: query.receiptNumber };
    
    handleVerifyReceipt(rcpt);
  };

  const handleOTPSubmit = (otpQuery) => {
    
    dispatch(rmSagaActions.verifyOTPCode(otpQuery));
        
    //do something to receipt stat to render service
  };

  

  //sky, 15/05/2022, commented out code below, ref: tracker # 17759

  // const getServiceRenderRpt = (refNum) => {

  //   let reportQueryParams = {
  //     reportFileNameWithExt: "agency-receipt-verification.jrxml",
  //     parameters: [
  //       {
  //         paramName: "p_receiptNumber",
  //         paramValue: verifiedReceipt.rcpt_number,
  //         paramDataType: "java.lang.String"
  //       },
  //       {
  //         paramName: "p_refNumber",
  //         paramValue: refNum,
  //         paramDataType: "java.lang.String"
  //       },
  //       {
  //         paramName: "p_departmentId",
  //         paramValue: provAgencyId,
  //         paramDataType: "java.lang.Integer"
  //       }
  //     ],
  //     generatedFileName: "Service Render Confirmation",
  //     reportOutputTypeCode: "PDF",
  //     saveFile: false
  //   };
    
  //   setDownloadReport(true);
  //   dispatch(rmSagaActions.fetchReportStr(reportQueryParams));
  // };

  const handleServiceRender = (details) => {
    let id = verifiedReceipt.rcpt_id;
    let rcptUptInfo = {
      receipt_status_id: usedRcptStatId.id,
      description: details.description,
      ref_number: details.refNumber
    };

    dispatch(rmSagaActions.renderService(provAgencyId, id, rcptUptInfo));

    //sky, 15/05/2022, commented out code below, ref: tracker # 17759
    //getServiceRenderRpt(details.refNumber);
    
  };

  const reset = () => {
    setSearchMade(false);
    setShowVerificationModal(false);
    setServRndModal(false);
    setSearchedRcpt("");

    dispatch(rmSagaActions.reset());
  };

  const closeVerificationModal = () => {
    setShowVerificationModal(false);
    setSearchedRcpt("");
  };

  const cancelVerification = () => {
    setSearchMade(false);
    setShowVerificationModal(false);
    setServRndModal(false);
    setSearchedRcpt("");
    reset();
  };

  const closeServRnd = () => {
    setServRndModal(false);
    setSearchedRcpt("");
  };

  const closeRcptNotFound = () => {
    setReceiptNotFound(false);
    setSearchedRcpt("");
  };

  return (
    <>
    <Card>
      <Card.Header>
        <h4>
          <Search size={24} className="mr-5" />
          Receipt Verification
        </h4>
      </Card.Header>
      <Card.Body>
        <ReceiptVerifyModal
          show={showVerificationModal}
          status={currRcptStat}
          receiptInfo={verifiedReceiptFound}
          otpVerified={otpVerified}
          otpVerifiedRes={otpVerifiedResponse}
          verifyingOTP={verifyingOTP}
          onCloseModal={closeVerificationModal}
          cancel={cancelVerification}
          handleOTPSubmit={handleOTPSubmit}
          handleOTPResend={handleOTPSend}
        />

        <ReceiptNotFound 
          show={receiptNotFound}
          onClose={closeRcptNotFound}
          receiptNumber={searchedRcpt}
        />

        <Formik
          initialValues={initialParam}
          validationSchema={verificationFormSchema}
          onSubmit={(values, {setSubmitting}) => {
            setSubmitting(true);
            handleFindReceipt(values);
            setSubmitting(false);
          }}
        >
          { ({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, handleReset }) => (
            <Form>
              <Form.Row>
                <Col lg={5} md={12} sm={12}>
                  <Form.Group controlId="paramReceiptNumber">
                    <Form.Label> <b> Receipt Number </b> </Form.Label>
                    <Form.Control
                      name="receiptNumber"
                      placeholder="Enter receipt number"
                      value={values.receiptNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={touched.receiptNumber && errors.receiptNumber && { border: "1px solid red",  boxShadow: "0 0 5px #F47174" } }
                    />
                    {touched.receiptNumber && errors.receiptNumber ? <div className={styles.formErrorMsg}>{errors.receiptNumber}</div> : null}
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row>
                <Button 
                  variant="primary" 
                  type="submit" 
                  onClick={handleSubmit}
                  style={{ display: "flex", alignItems: "center"}}
                  disabled={isSubmitting}
                >
                  { searchingRcpt ? <Spinner animation="border" size="sm" /> : <FileEarmarkCheck size="15" /> } &nbsp; Verify Receipt
                </Button>
                &nbsp;
                <Button 
                  variant="secondary" 
                  onClick={(e) => { handleReset(e); reset(); }}
                >
                  Clear
                </Button>
              </Form.Row>
            </Form>
          )}          
        </Formik>
      </Card.Body>
    </Card>
    <Card>
      <Card.Body>
        <ServiceRender
          display={servRndModal}
          onCloseModal={closeServRnd} 
          onHandleServiceRender={handleServiceRender} 
          receiptInfo={verifiedReceiptFound}
          updatingRcptStat={updatingRcptStat}
          otpVerified={otpVerified}
          cancel={cancelVerification}
        />
        
        { 
          receiptStatusUpdated ?
            <Row className={styles.modalRcptInfo}>
              <Col lg={1} md={12} sm={12}>
                <Check2Circle size={70} color="green" className="mr-5" /> 
              </Col>
              <Col lg md={12} sm={12}>
                Receipt <b> {verifiedReceiptFound.rcpt_number} </b> successfully verified and its status has been updated to <b>USED</b>. 
                <br/>
                <br/>
                Please render service, <b> {verifiedReceiptFound.service_item_number}: {verifiedReceiptFound.service_item_desc}</b> to customer, <b>{verifiedReceiptFound.cust_first_name + " " + verifiedReceiptFound.cust_last_name}</b>.
                <br/>
                {/* <div>
                  <Download size={26} /> {" "} 
                  <Button variant="link" onClick={() => { downloadPDFReport(reportDataStr); }}>
                    Service Confirmation Receipt
                  </Button>
                </div> */}
              </Col>
            </Row>
          : <div className="d-flex justify-content-center">
              Enter a receipt number to verify and render a service.
            </div>
        }
      </Card.Body>
    </Card>
    </>
  );
};
